import { render, staticRenderFns } from "./CardInfoV0.vue?vue&type=template&id=2c1b356f&scoped=true&"
import script from "./CardInfoV0.vue?vue&type=script&lang=js&"
export * from "./CardInfoV0.vue?vue&type=script&lang=js&"
import style0 from "./CardInfoV0.vue?vue&type=style&index=0&id=2c1b356f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1b356f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c1b356f')) {
      api.createRecord('2c1b356f', component.options)
    } else {
      api.reload('2c1b356f', component.options)
    }
    module.hot.accept("./CardInfoV0.vue?vue&type=template&id=2c1b356f&scoped=true&", function () {
      api.rerender('2c1b356f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/CardInfo/Agent/CardInfoV0.vue"
export default component.exports